module.exports = __webpack_public_path__ + "static/img/evgeni.5edc590.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/subscribe/evgeni.png
// module id = T4NA
// module chunks = 1